import { Injector, NgModule } from '@angular/core';

export let InjectorInstance: Injector;

@NgModule({
  declarations: [],
  imports: [],
  providers: []
})

export class InjectorModule {
  constructor(private injector: Injector) {
    InjectorInstance = this.injector;
  }
}
